import apiFetch from '../apiFetch'

export default function (idCliente, token) {
  return apiFetch({endPoint: `Combos/getDireccionesClienteSinPredeterminado?idCliente=` + idCliente, method: 'GET', body: null, token: token})
}